export const EVIDENCE_TYPES = [
  {
    key: "invoice",
    label: "فاتورة التطبيق",
    guide: "صوّر فاتورة التطبيق كاملة وواضحة داخل الإطار.",
    guideType: "invoice",
  },
  {
    key: "order",
    label: "المنتجات قبل التغليف",
    guide:
      "صوّر جميع المنتجات بوضوح قبل التغليف: الأطباق والساندويتشات والمشروبات والإضافات.",
    guideType: "order",
  },
  {
    key: "both",
    label: "الطلب المغلف + فاتورة التطبيق",
    guide:
      "صوّر الطلب بعد التغليف داخل الكيس مع فاتورة التطبيق بوضوح في نفس الصورة.",
    guideType: "both",
  },
  {
    key: "courier",
    label: "جوال المندوب + الطلب + الفاتورة",
    guide: "أظهر شاشة جوال المندوب والطلب والفاتورة معًا.",
    guideType: "courier",
  },
];
export const OUTCOME_LABELS = {
  normal: "لا توجد حالة خاصة",
  rejected: "مرفوض",
  cancelled: "ملغي من التطبيق",
  deliveryManDidntGet: "المندوب لم يستلم الطلب",
};
export const CONCLUSION_OPTIONS = [
  {
    value: "rejected",
    label: "مرفوض",
    reasons: [
      { value: "unavailable", label: "غير متوفر" },
      { value: "prayer_time", label: "وقت صلاة" },
      { value: "order_issue", label: "مشكلة في الطلب" },
      { value: "payment_issue", label: "مشكلة دفع" },
      { value: "branch_rejected", label: "رفض من الفرع" },
      { value: "other", label: "أخرى" },
    ],
  },
  {
    value: "cancelled",
    label: "ملغي من التطبيق",
    reasons: [
      { value: "customer_cancelled", label: "إلغاء من العميل" },
      { value: "app_cancelled", label: "إلغاء من التطبيق" },
      { value: "unavailable", label: "غير متوفر" },
      { value: "prayer_time", label: "وقت صلاة" },
      { value: "other", label: "أخرى" },
    ],
  },
  {
    value: "deliveryManDidntGet",
    label: "المندوب لم يستلم الطلب",
    reasons: [
      { value: "driver_no_show", label: "المندوب لم يصل" },
      { value: "driver_left", label: "المندوب وصل ثم غادر" },
      { value: "driver_late", label: "تأخر المندوب" },
      { value: "driver_refused_pickup", label: "رفض المندوب استلام الطلب" },
      { value: "driver_unreachable", label: "تعذر التواصل مع المندوب" },
      { value: "other", label: "سبب آخر" },
    ],
  },
];
export const conclusionLabel = (type) =>
  CONCLUSION_OPTIONS.find((item) => item.value === type)?.label ||
  OUTCOME_LABELS[type] ||
  type;
export const conclusionReasonLabel = (type, reason) =>
  CONCLUSION_OPTIONS.find((item) => item.value === type)?.reasons.find(
    (item) => item.value === reason,
  )?.label || reason;
export const fileAt = (order, key) => order?.evidence?.[key] || null;
export const isLocked = (order) =>
  Date.now() - new Date(order.createdAt).getTime() >= 86400000;

export const nextRequiredEvidence = (order) =>
  EVIDENCE_TYPES.find(
    (type) =>
      order?.requiredEvidenceTypes?.includes(type.key) &&
      !order?.evidence?.[type.key],
  ) || null;
